// The queue stays app-side; this wiring supplies its hook to @heidi/utils.
import { useQueuedModal } from '@/hooks/useQueuedModal';
import { configureQueuedModal } from '@heidi/utils';

configureQueuedModal(useQueuedModal);
